// Components==============
import Checkbox from 'components/UI/Checkbox/Checkbox';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { DeleteModalContext } from '../../DeleteModal';
import './Checkboxes.module.scss';
// =========================

export default function Checkboxes() {
  const translate = useTranslate();
  const {
    themeIsChecked,
    processIsChecked,
    setProcessIsChecked,
    setThemeIsChecked,
    ownerOfPublicTheme,
  } = useContext(DeleteModalContext);

  const { rootProject } = useContext(ProjectDetailsContext);

  return (
    <>
      <p>{translate('project.actions.delete-process-description')}</p>
      <div styleName="wrapper">
        <Checkbox isChecked={themeIsChecked} setIsChecked={setThemeIsChecked}>
          {translate('project.actions.delete-theme')}{' '}
          {!!ownerOfPublicTheme && translate('project.terms.from-my-project')}
        </Checkbox>

        {!!rootProject?.process?.length && (
          <Checkbox
            isChecked={processIsChecked || themeIsChecked}
            setIsChecked={setProcessIsChecked}
          >
            {translate('project.actions.delete-process')}
          </Checkbox>
        )}
      </div>
    </>
  );
}
